module.exports = __webpack_public_path__ + "static/media/guarantee-product-1.ab8c5868.png";